
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
:host([disabled]) {
  pointer-events: none;
  max-width: 100%;
}

:host {
  display: inline-block;
  outline: none;
}
:host slot::slotted(slh-icon) {
  fill: currentColor;
}

:host input[type=button] {
  display: none;
}

:host label {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: unset;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  user-select: none;
  text-transform: none;
  border-radius: 48px;
  font-family: var(--slh-default-font-family, "Open Sans");
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  background-color: var(--slh-color-primary-shade-40, #DAECFF);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-size: var(--slh-base-m-font-size, 16px);
  font-style: normal;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 24px;
  padding-right: 24px;
}
:host label.no-label {
  width: 48px;
  display: inline-block;
  padding-left: 12px;
  padding-right: 12px;
}
:host label.ghost {
  padding-top: calc(12px - 2px);
  padding-bottom: calc(12px - 2px);
}
:host label span {
  flex: 1 0 0;
  line-height: var(--slh-base-xxs-line-height, 24px);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;
}
:host label slot[name^=icon]:not([color]) {
  fill: currentColor;
}
:host label slot[name^=icon], :host label slot[name^=icon]::slotted(*) {
  display: inline-block;
  align-items: center;
  max-height: var(--slh-base-xxs-line-height, 24px);
}
:host label slot[name=icon-left]::slotted(*) {
  flex: 0 1 auto;
  margin-right: 8px;
  margin-left: -4px;
}
:host label:focus {
  background-color: var(--slh-color-primary-shade-40, #DAECFF);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
}
:host label.no-label slot::slotted(*), :host label.no-label slot[name^=icon], :host label.no-label slot[name^=icon]::slotted(*) {
  display: flex;
}
:host label.no-label slot[name^=icon-]::slotted(*) {
  margin: 0;
}
:host label.no-label:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
}
:host label.no-label:focus slot {
  filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
}
:host label:hover:not([disabled]) {
  background-color: var(--slh-color-primary-shade-60, #89B7E5);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host label.secondary {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host label.secondary:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host label.secondary:hover:not([disabled]) {
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  color: var(--slh-color-neutral, #39455D);
}
:host label.tertiary {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  background: transparent;
}
:host label.tertiary:focus {
  filter: none;
  -webkit-filter: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: var(--slh-color-neutral, #39455D);
  text-decoration: underline;
}
:host label.tertiary:hover:not([disabled]) {
  background-color: transparent;
  color: var(--slh-color-neutral, #39455D);
}
:host label.tertiary:disabled, :host label.tertiary[disabled] {
  background-color: transparent;
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host label.tertiary.negative:not([disabled]) {
  color: var(--slh-color-error-shade-60, #FFB6AD);
  background: transparent;
}
:host label.tertiary.negative:not([disabled]):hover {
  border: 0;
}
:host label.ghost {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  border: 2px solid var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host label.ghost:focus {
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host label.ghost:hover:not([disabled]) {
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
  color: var(--slh-color-neutral, #39455D);
}
:host label.ghost:disabled {
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  border: 2px solid var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host label:disabled, :host label[disabled] {
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  cursor: not-allowed;
}
:host label slot[name=icon-right]::slotted(*) {
  flex: 0 1 auto;
  margin-left: 8px;
  margin-right: -4px;
}
:host label.small {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
}
:host label.small.no-label {
  width: 40px;
  display: inline-block;
  padding-left: 8px;
  padding-right: 8px;
}
:host label.small.ghost {
  padding-top: calc(8px - 2px);
  padding-bottom: calc(8px - 2px);
}
:host label.negative:not([disabled]) {
  background: var(--slh-color-error-shade-60, #FFB6AD);
  color: var(--slh-color-neutral, #39455D);
}
:host label.negative:not([disabled]):hover {
  background: var(--slh-color-error-shade-80, #FFA399);
  color: var(--slh-color-neutral, #39455D);
}
:host label.negative:not([disabled]):focus {
  background: var(--slh-color-error-shade-80, #FFA399);
  filter: drop-shadow(0px 2px 2px rgba(221, 83, 80, 0.25));
  -webkit-filter: drop-shadow(0px 2px 2px rgba(221, 83, 80, 0.25));
}

:host([size=sm]) label {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
}
:host([size=sm]) label.no-label {
  width: 40px;
  display: inline-block;
  padding-left: 8px;
  padding-right: 8px;
}
:host([size=sm]) label.ghost {
  padding-top: calc(8px - 2px);
  padding-bottom: calc(8px - 2px);
}

:host([size=md]) label {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 24px;
  padding-right: 24px;
}
:host([size=md]) label.no-label {
  width: 48px;
  display: inline-block;
  padding-left: 12px;
  padding-right: 12px;
}
:host([size=md]) label.ghost {
  padding-top: calc(12px - 2px);
  padding-bottom: calc(12px - 2px);
}
:host([size=md]) label.no-label slot[name^=icon-]::slotted(*) {
  margin: 0;
}

@media (min-width: 560px) {
  :host([size-sm=sm]) label {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
  :host([size-sm=sm]) label.no-label {
    width: 40px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
  }
  :host([size-sm=sm]) label.ghost {
    padding-top: calc(8px - 2px);
    padding-bottom: calc(8px - 2px);
  }
  :host([size-sm=md]) label {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 24px;
    padding-right: 24px;
  }
  :host([size-sm=md]) label.no-label {
    width: 48px;
    display: inline-block;
    padding-left: 12px;
    padding-right: 12px;
  }
  :host([size-sm=md]) label.ghost {
    padding-top: calc(12px - 2px);
    padding-bottom: calc(12px - 2px);
  }
  :host([size-sm=md]) label.no-label slot[name^=icon-]::slotted(*) {
    margin: 0;
  }
}
@media (min-width: 768px) {
  :host([size-md=sm]) label {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
  :host([size-md=sm]) label.no-label {
    width: 40px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
  }
  :host([size-md=sm]) label.ghost {
    padding-top: calc(8px - 2px);
    padding-bottom: calc(8px - 2px);
  }
  :host([size-md=md]) label {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 24px;
    padding-right: 24px;
  }
  :host([size-md=md]) label.no-label {
    width: 48px;
    display: inline-block;
    padding-left: 12px;
    padding-right: 12px;
  }
  :host([size-md=md]) label.ghost {
    padding-top: calc(12px - 2px);
    padding-bottom: calc(12px - 2px);
  }
  :host([size-md=md]) label.no-label slot[name^=icon-]::slotted(*) {
    margin: 0;
  }
}
@media (min-width: 992px) {
  :host([size-lg=sm]) label {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
  :host([size-lg=sm]) label.no-label {
    width: 40px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
  }
  :host([size-lg=sm]) label.ghost {
    padding-top: calc(8px - 2px);
    padding-bottom: calc(8px - 2px);
  }
  :host([size-lg=md]) label {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 24px;
    padding-right: 24px;
  }
  :host([size-lg=md]) label.no-label {
    width: 48px;
    display: inline-block;
    padding-left: 12px;
    padding-right: 12px;
  }
  :host([size-lg=md]) label.ghost {
    padding-top: calc(12px - 2px);
    padding-bottom: calc(12px - 2px);
  }
  :host([size-lg=md]) label.no-label slot[name^=icon-]::slotted(*) {
    margin: 0;
  }
}
@media (min-width: 1200px) {
  :host([size-xl=sm]) label {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
  :host([size-xl=sm]) label.no-label {
    width: 40px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
  }
  :host([size-xl=sm]) label.ghost {
    padding-top: calc(8px - 2px);
    padding-bottom: calc(8px - 2px);
  }
  :host([size-xl=md]) label {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 24px;
    padding-right: 24px;
  }
  :host([size-xl=md]) label.no-label {
    width: 48px;
    display: inline-block;
    padding-left: 12px;
    padding-right: 12px;
  }
  :host([size-xl=md]) label.ghost {
    padding-top: calc(12px - 2px);
    padding-bottom: calc(12px - 2px);
  }
  :host([size-xl=md]) label.no-label slot[name^=icon-]::slotted(*) {
    margin: 0;
  }
}
@media (min-width: 1400px) {
  :host([size-xxl=sm]) label {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
  :host([size-xxl=sm]) label.no-label {
    width: 40px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
  }
  :host([size-xxl=sm]) label.ghost {
    padding-top: calc(8px - 2px);
    padding-bottom: calc(8px - 2px);
  }
  :host([size-xxl=md]) label {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 24px;
    padding-right: 24px;
  }
  :host([size-xxl=md]) label.no-label {
    width: 48px;
    display: inline-block;
    padding-left: 12px;
    padding-right: 12px;
  }
  :host([size-xxl=md]) label.ghost {
    padding-top: calc(12px - 2px);
    padding-bottom: calc(12px - 2px);
  }
  :host([size-xxl=md]) label.no-label slot[name^=icon-]::slotted(*) {
    margin: 0;
  }
}
:host .loading slot::slotted(.icon-wrapper) {
  display: none !important;
}

:host label[disabled],
:host label.no-label[disabled],
:host label.secondary[disabled] {
  filter: none;
}

:host label {
  transform: perspective(1px) translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
  backface-visibility: hidden;
  position: relative;
}
:host label:not(.tertiary):not(.secondary):not(.ghost):not(.negative):not([disabled])::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  border: 1.5px solid var(--slh-color-primary-shade-60, #89B7E5);
  box-sizing: border-box;
  border-radius: 48px;
}
:host label:hover:not(.tertiary):not(.secondary):not(.ghost):not([disabled]):not(.negative) {
  background-color: var(--slh-color-primary-shade-60, #89B7E5);
  color: var(--slh-color-neutral, #39455D);
}
:host label:hover:not(.tertiary), :host label:active:not(.tertiary) {
  -webkit-animation-name: hoverPop;
  animation-name: hoverPop;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}
:host label:focus:not(.tertiary):not(.secondary):not(.ghost):not([disabled]):not(.negative) {
  background-color: var(--slh-color-primary-shade-60, #89B7E5);
  color: var(--slh-color-neutral, #39455D);
}
:host label.secondary:not([disabled]):focus {
  color: var(--slh-color-neutral, #39455D);
}
:host label:focus, :host label:focus-visible {
  outline: none;
}
:host label:focus:not(.tertiary):not(.negative):not([disabled]), :host label.secondary:not([disabled]):focus {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
}
:host label.no-label:not(.tertiary):not(.negative):not([disabled]):focus {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
}
:host label.no-label:not(.tertiary):not(.negative):not([disabled]):focus slot {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
}
:host label.tertiary {
  text-decoration: none;
}
:host label.tertiary:hover, :host label.tertiary:focus {
  text-decoration: underline var(--slh-color-primary-darken, #2867A2);
  text-underline-offset: 3px;
}
:host label.ghost:hover:not([disabled]) {
  border-color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host label.ghost:focus:not([disabled]) {
  color: var(--slh-color-neutral, #39455D);
  border-color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host label.ghost:not([disabled]):focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  position: absolute;
  top: -6px;
  left: -6px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 48px;
}
:host label.negative:not([disabled]):focus {
  background: var(--slh-color-error-shade-60, #FFB6AD);
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
}
:host label slot[name=icon-left]::slotted(*) {
  margin-left: -8px;
}
:host label.small slot[name=icon-right]::slotted(*) {
  margin-left: 4px;
}
:host label.small slot[name=icon-left]::slotted(*) {
  margin-right: 4px;
}
:host label:not([disabled]):focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 48px;
}
:host label:not([disabled]):not(.no-label):focus-visible {
  outline: none;
}

@-webkit-keyframes hoverPop {
  50% {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
}
@keyframes hoverPop {
  50% {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
}
`;
